import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "27",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M.98 26.64c-.234-.175-.351-.41-.351-.644s.117-.469.293-.644l10.605-11.543L.922 2.207A.87.87 0 0 1 .98.918a.87.87 0 0 1 1.29.059l11.25 12.187a.85.85 0 0 1 0 1.23L2.27 26.583a.87.87 0 0 1-1.29.059"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }